export default {
  state: {
    searchData: {
      type: "",
      search: "",
    },

    searchSelectData: null,
    actionsData: [],
    updateGrid: false,
  },

  getters: {
    getSearchData(state) {
      return state.searchData;
    },

    getSearchSelectData(state) {
      return state.searchSelectData
    },

    getActionsData(state) {
      return state.actionsData;
    },

    getUpdateGrid(state) {
      return state.updateGrid;
    },
  },

  mutations: {
    setSearchData(state, data) {
      state.searchData = {
        type: data.type,
        search: data.search,
      };
    },

    setSearchSelectData(state, data) {
      state.searchSelectData = data
    },

    setActionsData(state, data) {
      state.actionsData = data;
    },

    setUpdateGridStatus(state, status) {
      state.updateGrid = status;
    },
  },

  actions: {
    changeSearchData(context, data) {
      context.commit("setSearchData", data);
    },

    changeSearchSelectData(context, data) {
      context.commit("setSearchSelectData", data)
    },

    changeActionsData(context, data) {
      context.commit("setActionsData", data);
    },

    changeUpdateGridStatus(context, status) {
      context.commit("setUpdateGridStatus", status);
    },
  },
};

/*
state: um objeto que armazena os dados do estado da aplicação. Neste caso, há três propriedades:

searchData: um objeto que contém informações de busca, como o tipo de busca e o termo de pesquisa.
actionsData: uma matriz de objetos que armazena os dados das ações executadas pelo usuário.
updateGrid: um booleano que indica se a grade de dados deve ser atualizada.
getters: funções que retornam dados do estado para os componentes Vue. Há três getters definidos neste módulo:

getSearchData: retorna os dados de busca.
getActionsData: retorna os dados das ações.
getUpdateGrid: retorna o valor booleano indicando se a grade de dados deve ser atualizada.
mutations: funções que atualizam o estado. Há três mutations definidas neste módulo:

setSearchData: atualiza os dados de busca.
setActionsData: atualiza os dados das ações.
setUpdateGridStatus: atualiza o valor booleano que indica se a grade de dados deve ser atualizada.
actions: funções que executam operações assíncronas e podem chamar as mutations para atualizar o estado. Há três actions definidas neste módulo:

changeSearchData: chama a mutation setSearchData para atualizar os dados de busca.
changeActionsData: chama a mutation setActionsData para atualizar os dados das ações.
changeUpdateGridStatus: chama a mutation setUpdateGridStatus para atualizar o valor booleano que indica se a grade de dados deve ser atualizada.
*/
